export default __webpack_public_path__ + "df45bc989f2e0cba6c7faa9d49eb51cd.png";